<template>
  <div id="app2" class="app">
    <div class="row">
      <div class="col-12">
        <hero-banner :title="content.heroBanner"></hero-banner>
      </div>
    </div>
    <!-- Variant Selector (only in development/test mode) -->
    <div class="variant-selector" v-if="showVariantSelector">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="variant-selector-wrapper">
              <label>Varianta formular:</label>
              <select v-model="selectedVariant" @change="onVariantChange" class="variant-select">
                <option value="current">Curentă (Default)</option>
                <option value="wizard">Wizard (Pași progresivi)</option>
                <option value="validated">Validare (Feedback vizual)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="container margin-top-30 margin-bottom-70">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <!-- Varianta curentă -->
            <form-annual-tax 
              v-if="!formSubmitted && selectedVariant === 'current'" 
              :submitSuccessful="submitSuccessful"
            ></form-annual-tax>
            
            <!-- Varianta Wizard -->
            <form-annual-tax-wizard 
              v-if="!formSubmitted && selectedVariant === 'wizard'" 
              :submitSuccessful="submitSuccessful"
            ></form-annual-tax-wizard>
            
            <!-- Varianta cu Validare -->
            <form-annual-tax-validated 
              v-if="!formSubmitted && selectedVariant === 'validated'" 
              :submitSuccessful="submitSuccessful"
            ></form-annual-tax-validated>
            
            <thank-you-page v-if="formSubmitted"></thank-you-page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonForm from "./components/global/ButtonForm";
import HeroBanner from "./components/global/HeroBanner";
import ThankYouPage from "./components/formAnnualTax/ThankYouPage";

import FormAnnualTax from "./components/formAnnualTax/FormAnnualTax";
import FormAnnualTaxWizard from "./components/formAnnualTax/FormAnnualTaxWizard";
import FormAnnualTaxValidated from "./components/formAnnualTax/FormAnnualTaxValidated";

import Content from "./content/pages/FormAnnualTax";

import axios from "axios";

export default {
  name: "App2",
  data() {
    // Check URL parameter for variant, default to 'validated'
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant') || 'validated';
    
    return {
      content: Content,
      formSubmitted: false,
      selectedVariant: variantFromUrl, // 'current', 'wizard', or 'validated'
      showVariantSelector: false // Hidden - only variant 3 (validated) is used
    };
  },
  components: {
    ButtonForm,
    HeroBanner,
    FormAnnualTax,
    FormAnnualTaxWizard,
    FormAnnualTaxValidated,
    ThankYouPage
  },
  methods: {
    submitSuccessful: function() {
      this.formSubmitted = true;
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    onVariantChange: function() {
      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', this.selectedVariant);
      window.history.pushState({}, '', url);
    }
  }
};
</script>

<style lang="scss">
.app {
  height: 100%;
}

.main {
  position: relative;
  z-index: 10;
}

.container-form {
  position: relative;
  max-width: 100%;
  width: 100%;
  background-color: #fff;
  padding: 0;
  margin: 0 auto;
}

.margin-top-30 {
  margin-top: 30px !important;
}

.margin-top-70 {
  margin-top: 70px !important;
}

.margin-bottom-70 {
  margin-bottom: 70px !important;
}

.margin-top-42 {
  margin-top: 42px !important;
}

.margin-top-15 {
  margin-top: 15px !important;
}

.section-name-form {
  font-size: 20px;
  font-weight: 700;
  margin: 4px 0px;
}

.section-description-form {
  font-size: 1.1rem;
  font-weight: 300;
  color: #97a1ab;
}

.align-button-form {
  float: right;
}

@media (max-width: 700px) {
  .align-button-form {
    float: left;
  }
}

.datepicker-input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
}

.datepicker-error {
  display: block;
  border: 1px solid #bd1f23;
  color: #bd1f23 !important;
}

.variant-selector {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e2e8f0;
  padding: 15px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  
  .variant-selector-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    
    label {
      font-size: 14px;
      font-weight: 600;
      color: #4a5568;
      margin: 0;
    }
    
    .variant-select {
      padding: 8px 16px;
      border: 2px solid #e2e8f0;
      border-radius: 6px;
      background-color: #fff;
      font-size: 14px;
      font-weight: 500;
      color: #1a1a1a;
      cursor: pointer;
      min-width: 250px;
      
      &:focus {
        outline: none;
        border-color: #bd1f23;
        box-shadow: 0 0 0 2px rgba(189, 31, 35, 0.1);
      }
    }
  }
}
</style>
